module.exports = __webpack_public_path__ + "img/requirement1.8ea603f.png";